exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#app[data-v-3ae9a8a7]{width:100%;height:100%;display:flex;flex-direction:column;background-color:#333;overflow:hidden}#titlebar[data-v-3ae9a8a7]{display:flex;color:#fff;justify-content:space-between;padding:10px}h1[data-v-3ae9a8a7]{font-family:Arial;padding:0;margin:0;font-size:64px}.score[data-v-3ae9a8a7]{font-family:Arial;font-size:64px;font-weight:700}.score[data-v-3ae9a8a7]:before{content:\"Score: \";text-align:right;font-weight:400}.body-container[data-v-3ae9a8a7]{display:flex;justify-content:center;align-items:center;flex:1}.game-container[data-v-3ae9a8a7]{width:75vw;height:0;padding-top:26.75439vw;position:relative}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3ae9a8a7","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/App.vue
// module id = 12
// module chunks = 0